import { combineReducers } from '@reduxjs/toolkit';

import app from '../../modules/app/reducers';
import chat from '../../modules/chat/reducers';
import intl from '../../modules/app/intl/reducers';
import works from '../../modules/works/reducers';
import entity from '../../modules/entity/reducers';
import media from '../../modules/media/reducers';
import refdata from '../../modules/refdata/reducers';
import customers from '../../modules/customers/reducers';
import customize from '../../modules/entity/subEntities/customize/reducers';
import websockets from '../../modules/websockets/reducers';
import notifications from '../../modules/notifications/reducer';
import appointment from '../../modules/entity/subEntities/appointment/reducers';
import intervention from '../../modules/entity/subEntities/intervention/reducers';

const fleetbackAppReducers = combineReducers({
  app,
  appointment,
  chat,
  customers,
  customize,
  entity,
  intervention,
  intl,
  media,
  notifications,
  refdata,
  websockets,
  works,
});

export type RootState = ReturnType<typeof fleetbackAppReducers>;

export default fleetbackAppReducers;
